import { twMerge } from 'tailwind-merge';

const CouponSkeleton: React.FC<any> = ({ showBorder, className }) => {
  return (
    <div
      className={twMerge(
        'box-border px-3 rounded-500 pt-3 mb-5 overflow-hidden',
        showBorder ? 'border border-solid bg-surface-100-bg border-[rgba(0,0,0,0.05)]' : '',
        className
      )}>
      <div className="flex items-center justify-between pb-[13px]">
        <div className="flex items-center justify-between">
          <div className="w-3 h-3 rounded-700 mr-2.5 bg-surface-200-bg skeleton !bg-[10px_auto] default-img"></div>
          <div>
            <div className="h-[14px] w-[90px] bg-surface-200-bg skeleton"></div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <div className="w-[120px] h-10 bg-surface-200-bg skeleton"></div>
          <div className="w-[160px] h-[14px] mt-1 bg-surface-200-bg skeleton"></div>
        </div>
        <div>
          <div className="w-[90px] h-8 rounded-700 bg-surface-200-bg skeleton"></div>
          <div className="w-[100px] h-[14px] mt-3 bg-surface-200-bg skeleton"></div>
        </div>
      </div>

      <div className="flex items-center mt-2.5 -mx-3">
        {new Array(3).fill(0).map((item, index) => {
          return (
            <div className="w-1/3 skeleton" key={`product-${item}-${index}`}>
              <div className="pt-[100%] bg-surface-200-bg default-img"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CouponSkeleton;
